//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import { createSlice } from '@reduxjs/toolkit';

const initialState = Object.freeze({});

const generatePressArticleSlice = createSlice({
    name:     'generatePressArticle',
    initialState,
    reducers: {
        generatePressArticle: (state, action) => {
        },
    },
});

export const GeneratePressArticleActions = generatePressArticleSlice.actions;

export const GeneratePressArticleReducer = generatePressArticleSlice.reducer;

export default generatePressArticleSlice;
